import { createGlobalStyle } from 'styled-components';

const FontGlobalStyle = createGlobalStyle`
    ${props => props.font ? `html, body {
        font-family: '${props.font.family}', ${props.font.category}!important;
    }` 
    : ''}
`;

export default FontGlobalStyle;